module.exports = __webpack_public_path__ + "media/src/images/mails/badge_grade_b-bdae2367ae43537a6e8896f30376201f.png";